import React from "react";
import "../css/style.css";

import { connect } from "react-redux";
import i18next from "i18next";
import { confService, userService } from "../_services";
import { appActions, userActions } from "../_actions";
import Button from "@material-ui/core/Button";
import { history } from "../_helpers";

class PurchasedPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      error: "",
      isHasPermission: false,
      qrCode: "",
      pageText: "",
    };
  }

  componentDidMount() {
    const url = window.location.pathname;

    localStorage.setItem("navic_redirect_count", "");

    let self = this;
    if (url.indexOf("/purchased") >= 0) {
      const url_arr = url.replace("/purchased-", "").split("-");

      if (url_arr.length > 1) {
        if (url_arr.length > 3) {
          let token = url_arr[3].replace("%7C", "|");

          if (token != "0") {
            localStorage.setItem("token", token);

            this.props.dispatch(userActions.getuser());
          }
        }

        this.setState({ tid: url_arr[1] });
        confService.confInfo(
          url_arr[0],
          (data) => {
            self.setState({
              confName: data.data.name,
              confInfo: data.data,
              loadConfInfo: true,
            });
            console.log(data.data);

            if (self.state.loadConfInfo)
              self.getConfTicket(
                data.data.name,
                self.state.tickets,
                url_arr[0]
              );
          },
          (err) => {
            console.log(err);
          }
        );

        confService.ticketsInfo(
          url_arr[0],
          0,
          (data) => {
            self.setState({
              tickets: data.data,
              confInfo: data.data,
              loadTicketInfo: true,
            });

            if (self.state.loadConfInfo)
              self.getConfTicket(self.state.confName, data.data, url_arr[0]);
          },
          (err) => {
            console.log(err);
          }
        );

        this.props.dispatch(appActions.setpage("conf_view", url_arr[0]));
        //history.push("confi_view/"+url_arr[0]);
      }
    }
  }

  //{!isHasPermission && <h3>{i18next.t("has_no_permission")}</h3>}

  render() {
    const self = this;

    return <div className="layout">Loading....</div>;
  }
}

function mapStateToProps(state) {
  const { app, user, authentication } = state;

  return {
    user,
    app,
    authentication,
  };
}

const connectedPurchasedPage = connect(mapStateToProps)(PurchasedPage);
export { connectedPurchasedPage as PurchasedPage };
